export enum SubscriptionProducts {
  FLOORPLAN = 'FLOORPLAN',
  FLOORPLAN_EXTENDED = 'FLOORPLAN_EXTENDED',
  VIRTUAL_TOUR = 'VIRTUAL_TOUR',
  SCOPE_OF_WORK = 'SCOPE_OF_WORK',
  OVERNIGHT = 'OVERNIGHT',
  ESTIMATE = 'ESTIMATE',
  FIVE_HOUR_SKETCH = 'FIVE_HOUR_SKETCH',
  DEADLINE_PENALTY = 'DEADLINE_PENALTY',
}

export const SUBSCRIPTION_PRODUCTS_NAMES_MAP: Record<SubscriptionProducts, string> = {
  [SubscriptionProducts.FLOORPLAN]: 'Sketch',
  [SubscriptionProducts.FLOORPLAN_EXTENDED]: 'Sketch Extended',
  [SubscriptionProducts.FIVE_HOUR_SKETCH]: '5h Sketch',
  [SubscriptionProducts.DEADLINE_PENALTY]: 'Over-the-limit penalty',
  [SubscriptionProducts.VIRTUAL_TOUR]: '360° Tour',
  [SubscriptionProducts.SCOPE_OF_WORK]: 'Scope of Work',
  [SubscriptionProducts.OVERNIGHT]: 'Overnight Delivery',
  [SubscriptionProducts.ESTIMATE]: 'Estimate',
};

export enum AdditionalServicesEnum {
  FLOORPLAN = 'FLOORPLAN',
  FLOORPLAN_EXTENDED = 'FLOORPLAN_EXTENDED',
  VIRTUAL_TOUR = 'VIRTUAL_TOUR',
  SCOPE_OF_WORK = 'SCOPE_OF_WORK',
  OVERNIGHT = 'OVERNIGHT',
  ESTIMATE = 'ESTIMATE',
  INSTANT_FLOORPLAN = 'INSTANT_FLOORPLAN',
  INITIAL_ESTIMATE = 'INITIAL_ESTIMATE',
}

export const ADDITIONAL_SERVICES_NAMES_MAP: Record<AdditionalServicesEnum, string> = {
  [AdditionalServicesEnum.FLOORPLAN]: 'Sketch',
  [AdditionalServicesEnum.FLOORPLAN_EXTENDED]: 'Sketch Extended',
  [AdditionalServicesEnum.VIRTUAL_TOUR]: '360° Tour',
  [AdditionalServicesEnum.SCOPE_OF_WORK]: 'Scope of Work',
  [AdditionalServicesEnum.OVERNIGHT]: 'Overnight Delivery',
  [AdditionalServicesEnum.ESTIMATE]: 'Estimate',
  [AdditionalServicesEnum.INSTANT_FLOORPLAN]: 'Instant Sketch',
  [AdditionalServicesEnum.INITIAL_ESTIMATE]: 'Initial Estimate',
};

export enum CompanyTypeEnum {
  INTERNAL = 'INTERNAL',
  PILOT = 'TEST',
  BUSINESS = 'BUSINESS',
  PARTNER = 'PARTNER',
  TEST = 'TEST',
}

export const COMPANY_TYPE_NAMES_MAP: Record<CompanyTypeEnum, string> = {
  [CompanyTypeEnum.INTERNAL]: 'Internal',
  [CompanyTypeEnum.PILOT]: 'Pilot',
  [CompanyTypeEnum.BUSINESS]: 'Customer',
  [CompanyTypeEnum.PARTNER]: 'Partner',
};

export enum VerticalEnum {
  RESTORATION = 'RESTORATION',
  INSURTECH = 'INSURTECH',
  DOCUSKETCH = 'DOCUSKETCH',
  HOME_INSPECTION = 'HOME_INSPECTION',
  OTHER = 'OTHER',
}

export const VERTICAL_NAMES_MAP: Record<VerticalEnum, string> = {
  [VerticalEnum.RESTORATION]: 'Restoration',
  [VerticalEnum.INSURTECH]: 'InsurTech',
  [VerticalEnum.HOME_INSPECTION]: 'Home inspection',
  [VerticalEnum.DOCUSKETCH]: 'DokuSketch (internal)',
  [VerticalEnum.OTHER]: 'Other',
};

export enum RestorationIndustrySubcategoriesEnum {
  CONSULTANT = 'CONSULTANT',
  CONTENTS_COMPANY = 'CONTENTS_COMPANY',
  ENTERPRISE = 'ENTERPRISE',
  ENVIRONMENTS = 'ENVIRONMENTALIST',
  ESTIMATING = 'ESTIMATING',
  FORENSIC = 'FORENSIC',
  GENERAL_CONTRACTOR = 'GENERAL_CONTRACTOR',
  ROOFING = 'ROOFING',
}

export const RESTORATION_INDUSTRY_SUBCATEGORIES_NAMES_MAP: Record<RestorationIndustrySubcategoriesEnum, string> = {
  [RestorationIndustrySubcategoriesEnum.CONSULTANT]: 'Consultant',
  [RestorationIndustrySubcategoriesEnum.CONTENTS_COMPANY]: 'Contents company',
  [RestorationIndustrySubcategoriesEnum.ENTERPRISE]: 'Enterprise',
  [RestorationIndustrySubcategoriesEnum.ENVIRONMENTS]: 'Environmentalist',
  [RestorationIndustrySubcategoriesEnum.ESTIMATING]: 'Estimating',
  [RestorationIndustrySubcategoriesEnum.FORENSIC]: 'Forensic',
  [RestorationIndustrySubcategoriesEnum.GENERAL_CONTRACTOR]: 'General contractor',
  [RestorationIndustrySubcategoriesEnum.ROOFING]: 'Roofing',
};

export enum InsureTechIndustrySubcategoriesEnum {
  ADJUSTER_FIRM = 'ADJUSTER_FIRM',
  INDEPENDENT_ADJUSTER = 'INDEPENDENT_ADJUSTER',
  INSURANCE_CARRIER = 'INSURANCE_CARRIER',
  PUBLIC_ADJUSTER = 'PUBLIC_ADJUSTER',
  TPA = 'TPA',
}

export const INSURETECH_INDUSTRY_SUBCATEGORIES_NAMES_MAP: Record<InsureTechIndustrySubcategoriesEnum, string> = {
  [InsureTechIndustrySubcategoriesEnum.ADJUSTER_FIRM]: 'Adjuster firm',
  [InsureTechIndustrySubcategoriesEnum.INDEPENDENT_ADJUSTER]: 'Independent adjuster',
  [InsureTechIndustrySubcategoriesEnum.INSURANCE_CARRIER]: 'Insurance carrier',
  [InsureTechIndustrySubcategoriesEnum.PUBLIC_ADJUSTER]: 'Public adjuster',
  [InsureTechIndustrySubcategoriesEnum.TPA]: 'TPA',
};

export type IndustrySubcategoryEnum = RestorationIndustrySubcategoriesEnum | InsureTechIndustrySubcategoriesEnum;

export const INDUSTRIES_NAMES_MAP: Record<IndustrySubcategoryEnum, string> = {
  ...RESTORATION_INDUSTRY_SUBCATEGORIES_NAMES_MAP,
  ...INSURETECH_INDUSTRY_SUBCATEGORIES_NAMES_MAP,
};
